import classNames from 'classnames/bind';
import { ReactNode } from 'react';
import styles from './Card.module.scss';

const cx = classNames.bind(styles);

export interface CardProps {
    children: ReactNode;
    className?: string;
}

const Card = (props: CardProps) => {
    const { children, className } = props;

    return (
        <div className={cx('card', className)}>{children}</div>
    )
}

export default Card;